@use '@design/design-tokens/breakpoints/breakpoints' as *;

$timing-base: cubic-bezier(0.4, 0, 0.2, 1);

.logoButton {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  background-color: transparent;
  padding: 0;
}

.header {
  position: sticky;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--border-soft);
  height: var(--app-header-height);
  padding: 12px 16px;
  background-color: var(--background-soft);
  z-index: var(--z-index-app-header);

  @include respond-to('xl') {
    padding: 12px 20px;
  }
}

.styledLogotype {
  transition: transform 300ms $timing-base;

  img {
    transition: opacity 300ms $timing-base;
  }

  transform: translateX(-34px);

  @include respond-to('xl') {
    transform: translateX(0);
  }
}

.categories {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 12px 8px 12px 0;
  gap: 16px;
  overflow-x: clip;
}
